///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GtthBooleanToCheckMarkDirective } from './booleanToCheckmark.directive';
import { GtthProductNameLinkDirective } from './product-name-link.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [GtthBooleanToCheckMarkDirective, GtthProductNameLinkDirective],
    exports: [GtthBooleanToCheckMarkDirective, GtthProductNameLinkDirective],
    providers: []
})
export class GtthStyleDirectivesModule {}
